__turbopack_context__.v({
  "bgGradientBlack": "General-module__2L3fqG__bgGradientBlack",
  "bgGradientWhite": "General-module__2L3fqG__bgGradientWhite",
  "navFloat": "General-module__2L3fqG__navFloat",
  "singleBenefit": "General-module__2L3fqG__singleBenefit",
  "tableBenefits": "General-module__2L3fqG__tableBenefits",
});
